/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Monthly_After_TrialInputs */

const en_pricing_monthly_after_trial = /** @type {(inputs: Pricing_Monthly_After_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billed monthly, after your trial`)
};

const es_pricing_monthly_after_trial = /** @type {(inputs: Pricing_Monthly_After_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación mensual, después de la prueba`)
};

/**
* | output |
* | --- |
* | "Billed monthly, after your trial" |
*
* @param {Pricing_Monthly_After_TrialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_monthly_after_trial = /** @type {((inputs?: Pricing_Monthly_After_TrialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Monthly_After_TrialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_monthly_after_trial(inputs)
	return en_pricing_monthly_after_trial(inputs)
});